import { ExternalLink } from 'lucide-react';

/**
 * WI-14 (OPERATOR-UI-PLACEMENT): shared read-only primitives for the thin
 * operator console. Kept in one place so the run-group detail, evidence,
 * reconciliation, and worker-attempts surfaces render identically.
 */

/** An "open in Aldan Desktop" hand-off. The console never mutates in place. */
export function DeepLinkButton({ href, label }: { href: string; label: string }) {
  return (
    <a
      href={href}
      className="inline-flex items-center gap-1.5 rounded-md border border-slate-200 px-2.5 py-1 text-xs font-medium text-slate-600 hover:bg-slate-50 hover:text-slate-900"
    >
      <ExternalLink className="h-3.5 w-3.5" />
      {label}
    </a>
  );
}

export function StatusPill({ status }: { status: string }) {
  return (
    <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600">
      {status}
    </span>
  );
}

/** A labelled read-only field for the projection detail grids. */
export function Field({
  label,
  value,
  mono,
}: {
  label: string;
  value: React.ReactNode;
  mono?: boolean;
}) {
  return (
    <div>
      <dt className="text-xs text-slate-400">{label}</dt>
      <dd
        className={`mt-0.5 text-sm font-medium text-slate-700 ${mono ? 'font-mono' : ''}`}
      >
        {value === null || value === undefined || value === '' ? (
          <span className="text-slate-300">—</span>
        ) : (
          value
        )}
      </dd>
    </div>
  );
}
